import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { IeLynxObject } from "../../common/models/eLynxObject";

export const keys = {
    all: ["alarm-setpoints"],
    lists: () => [
        ...keys.all,
        "list"
    ],
    list: (groupID: number, eLynxObject: IeLynxObject) => [
        ...keys.lists(),
        {
            groupID,
            eLynxObject
        }
    ],
    disableSchedules: () => [
        ...keys.all,
        "disable-schedule"
    ],
    disableSchedule: (groupID: number, tagID: number, setpointID: number) => [
        ...keys.disableSchedules(),
        {
            groupID,
            tagID,
            setpointID
        }
    ],
    objectDisableSchedules: () => [
        ...keys.all,
        "object-disable-schedule"
    ],
    objectDisableSchedule: (groupID: number, objectType: eLynxObjectTypeEnum, objectID: number) => [
        ...keys.objectDisableSchedules(),
        {
            groupID,
            objectType,
            objectID
        }
    ]

};

